import { useEffect, useState } from 'react';
import { api } from '../api.ts';
import type { SiteConfig } from '../siteContentTypes.ts';

export function useSiteContent(preview: boolean) {
  const [config, setConfig] = useState<SiteConfig | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const path = preview ? '/site-content/draft' : '/site-content/published';
    api
      .get<{ config: SiteConfig }>(path)
      .then((res) => {
        if (!cancelled) setConfig(res.config);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, [preview]);

  return { config, error };
}
